/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_My_BookingsInputs */

const en_nav_my_bookings = /** @type {(inputs: Nav_My_BookingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`My Bookings`)
};

const es_nav_my_bookings = /** @type {(inputs: Nav_My_BookingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mis reservas`)
};

const de_nav_my_bookings = /** @type {(inputs: Nav_My_BookingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meine Buchungen`)
};

const zh_nav_my_bookings = /** @type {(inputs: Nav_My_BookingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我的预订`)
};

const ar_nav_my_bookings = /** @type {(inputs: Nav_My_BookingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حجوزاتي`)
};

const fr_nav_my_bookings = /** @type {(inputs: Nav_My_BookingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mes réservations`)
};

const vi_nav_my_bookings = /** @type {(inputs: Nav_My_BookingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đặt chỗ của tôi`)
};

const sw_nav_my_bookings = /** @type {(inputs: Nav_My_BookingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nafasi Zangu`)
};

const th_nav_my_bookings = /** @type {(inputs: Nav_My_BookingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`การจองของฉัน`)
};

const bs_nav_my_bookings = /** @type {(inputs: Nav_My_BookingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moje rezervacije`)
};

const ja_nav_my_bookings = /** @type {(inputs: Nav_My_BookingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`予約一覧`)
};

const ko_nav_my_bookings = /** @type {(inputs: Nav_My_BookingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`내 예약`)
};

const pt_nav_my_bookings = /** @type {(inputs: Nav_My_BookingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minhas Reservas`)
};

const it_nav_my_bookings = /** @type {(inputs: Nav_My_BookingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le mie prenotazioni`)
};

const sv_nav_my_bookings = /** @type {(inputs: Nav_My_BookingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mina bokningar`)
};

const nl_nav_my_bookings = /** @type {(inputs: Nav_My_BookingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mijn boekingen`)
};

const da_nav_my_bookings = /** @type {(inputs: Nav_My_BookingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mine bookinger`)
};

const nb_nav_my_bookings = /** @type {(inputs: Nav_My_BookingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mine bestillinger`)
};

const fi_nav_my_bookings = /** @type {(inputs: Nav_My_BookingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Varaukseni`)
};

const pl_nav_my_bookings = /** @type {(inputs: Nav_My_BookingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moje rezerwacje`)
};

const ru_nav_my_bookings = /** @type {(inputs: Nav_My_BookingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Мои бронирования`)
};

const tr_nav_my_bookings = /** @type {(inputs: Nav_My_BookingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rezervasyonlarım`)
};

const hi_nav_my_bookings = /** @type {(inputs: Nav_My_BookingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मेरी बुकिंग`)
};

const id_nav_my_bookings = /** @type {(inputs: Nav_My_BookingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pemesanan saya`)
};

const ms_nav_my_bookings = /** @type {(inputs: Nav_My_BookingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempahan Saya`)
};

const cs_nav_my_bookings = /** @type {(inputs: Nav_My_BookingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mé rezervace`)
};

const el_nav_my_bookings = /** @type {(inputs: Nav_My_BookingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Οι κρατήσεις μου`)
};

const he_nav_my_bookings = /** @type {(inputs: Nav_My_BookingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ההזמנות שלי`)
};

const af_nav_my_bookings = /** @type {(inputs: Nav_My_BookingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`My besprekings`)
};

const hu_nav_my_bookings = /** @type {(inputs: Nav_My_BookingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Foglalásaim`)
};

/**
* | output |
* | --- |
* | "My Bookings" |
*
* @param {Nav_My_BookingsInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const nav_my_bookings = /** @type {((inputs?: Nav_My_BookingsInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_My_BookingsInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_nav_my_bookings(inputs)
	if (locale === "de") return de_nav_my_bookings(inputs)
	if (locale === "zh") return zh_nav_my_bookings(inputs)
	if (locale === "ar") return ar_nav_my_bookings(inputs)
	if (locale === "fr") return fr_nav_my_bookings(inputs)
	if (locale === "vi") return vi_nav_my_bookings(inputs)
	if (locale === "sw") return sw_nav_my_bookings(inputs)
	if (locale === "th") return th_nav_my_bookings(inputs)
	if (locale === "bs") return bs_nav_my_bookings(inputs)
	if (locale === "ja") return ja_nav_my_bookings(inputs)
	if (locale === "ko") return ko_nav_my_bookings(inputs)
	if (locale === "pt") return pt_nav_my_bookings(inputs)
	if (locale === "it") return it_nav_my_bookings(inputs)
	if (locale === "sv") return sv_nav_my_bookings(inputs)
	if (locale === "nl") return nl_nav_my_bookings(inputs)
	if (locale === "da") return da_nav_my_bookings(inputs)
	if (locale === "nb") return nb_nav_my_bookings(inputs)
	if (locale === "fi") return fi_nav_my_bookings(inputs)
	if (locale === "pl") return pl_nav_my_bookings(inputs)
	if (locale === "ru") return ru_nav_my_bookings(inputs)
	if (locale === "tr") return tr_nav_my_bookings(inputs)
	if (locale === "hi") return hi_nav_my_bookings(inputs)
	if (locale === "id") return id_nav_my_bookings(inputs)
	if (locale === "ms") return ms_nav_my_bookings(inputs)
	if (locale === "cs") return cs_nav_my_bookings(inputs)
	if (locale === "el") return el_nav_my_bookings(inputs)
	if (locale === "he") return he_nav_my_bookings(inputs)
	if (locale === "af") return af_nav_my_bookings(inputs)
	if (locale === "hu") return hu_nav_my_bookings(inputs)
	return en_nav_my_bookings(inputs)
});